import { useEffect, useState } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../config/firebase';

/**
 * Feed roles from the signed-in user's token (Firebase custom claims, set by
 * cloud-management/gcp/set-curator.js). `refresh()` forces a token refresh
 * so a newly granted role shows without logging out.
 */
export function useCuratorRole() {
  const [state, setState] = useState({
    loading: true,
    user: null,
    curator: false,
    feedAdmin: false,
  });

  useEffect(
    () =>
      onIdTokenChanged(auth, async (user) => {
        if (!user) {
          setState({
            loading: false,
            user: null,
            curator: false,
            feedAdmin: false,
          });
          return;
        }
        const { claims } = await user.getIdTokenResult();
        setState({
          loading: false,
          user,
          curator: claims.curator === true || claims.feedAdmin === true,
          feedAdmin: claims.feedAdmin === true,
        });
      }),
    []
  );

  const refresh = () => auth.currentUser?.getIdToken(true);

  return { ...state, refresh };
}
